import { createFileRoute } from '@tanstack/react-router'
import { PlaygroundSubPane } from './-components/dev/transition-playground'

export const Route = createFileRoute('/_app/dev-resources/transitions/jobs/$jobId/distribution/x')({
  component: () => <PlaygroundSubPane name="By level" />,
})
